export default __webpack_public_path__ + "static/media/navigation-tabs.26513b46.png";